import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '@fuse/animations';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ContainerOccupancyReport } from 'app/models/container-occupancy-report.model';
import { Poligon } from 'app/models/poligon.model';
import { RoutingSimulationReport } from 'app/models/routingSimulation.model';
import { ExcelService } from 'app/services/excel.service';
import { PoligonService } from 'app/services/poligon.service';
import { ReportingService } from 'app/services/reporting.service';
import { SimulationService } from 'app/services/simulation.service';
import { SetStartLocationComponent } from './set-start-location/set-start-location-form.component';
import { MatDialog } from '@angular/material/dialog';
import * as L from 'leaflet';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { GenericMapRoutingComponent } from './generic-map-routing/generic-map-routing.component';

@Component({
    selector: 'simulation-reporting',
    templateUrl: './simulation-reporting.component.html',
    styleUrls: ['./simulation-reporting.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: [ExcelService]
})
export class SimulationReportingComponent implements OnInit {
    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;

    public myLocation= new L.LatLng(0,0);
    public endDate = new Date();
    public startDate = new Date((new Date().setMonth(new Date().getMonth()-1)));
    
    private _routingSimulationReport : Array<RoutingSimulationReport>=[];
    public get routingSimulationReport() : Array<RoutingSimulationReport> {
        return this._routingSimulationReport;
    }
    public set routingSimulationReport(v : Array<RoutingSimulationReport>) {
        this._routingSimulationReport = v;
    }
    
    public tableLoading = false;
    public selectPoligon: Poligon;
    private _polygonList: Array<Poligon> = [];
    
    public get polygonList(): Array<Poligon> {
        return this._polygonList;
    }
    
    private _dataSource: MatTableDataSource<RoutingSimulationReport> = undefined;
    public get dataSource(): MatTableDataSource<RoutingSimulationReport> {
        return this._dataSource;
    }
    
    private _displayedColumns = ['poligonName', 'optimizeKm', 'optimizeCount','baseKm', 'baseCount','rate', 'date'];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }
    public chartLabel: string[] = [];
    public chartData: number[] = [];
    public chartOptions = {

        animation: {
            duration: 500,
            easing: "easeInOutQuad"
        },

        responsive: true,
        legend: {
            display: true,
            position: "right",
            fullWidth: false,
            reverse: true
        }
    };
    public colors =
        [{
            backgroundColor: [
                'rgba(44,110,70,255)',
                'rgba(241,196,15,255)',
                'rgba(230,126,34,255)',
                'rgba(164,45,26,255)'
            ]
        }
        ];

    chartFilled() {
        this.chartLabel = []
        this.chartLabel.push('0% - 25% ' + this._translateService.instant('OCCUPANCY'), '26% - 50% ' + this._translateService.instant('OCCUPANCY'), '51% - 75% ' + this._translateService.instant('OCCUPANCY'), '76% - 100% ' + this._translateService.instant('OCCUPANCY'));
        this.chartData.push(0, 0, 0);
    }


    constructor(
        private _reportingService: ReportingService,
        private _toasterService:ToasterService,
        private _dialog: MatDialog,
        private _polygonService: PoligonService,
        private _translateService: TranslateService,
        private _excelService: ExcelService
    ) {
        this._translateService.onLangChange.subscribe((event: LangChangeEvent) => {
            this.chartLanguageChange();

        });
    }
    chartLanguageChange() {
        this.chartFilled();
    }

    public async ngOnInit() {
        this.chartFilled();
        this.myLocation =  await this.getCurrentLocation();
        await this.getPoligonList();
        this.getRoutingSimulation();
        this.updateTableDataSource()
    }

    public async getPoligonList() {
        try {
            this._polygonList = await this._polygonService.getPoligons(parseInt(localStorage.getItem("CompanyID")));
            this.selectPoligon = this.polygonList[0];
        } catch (error) {
            console.warn(error);
        }
    }
    
    public async selectPoligonClick(){
        this.getRoutingSimulation();
    }

    public async getRoutingSimulation() {
        this.tableLoading=true;
        try {
            this.routingSimulationReport = await this._reportingService.getRoutingSimulation(this.selectPoligon.id,this.startDate,this.endDate,this.myLocation.lat,this.myLocation.lng)            
            this.updateTableDataSource();
        this.tableLoading=false;

        } catch (error) {
            console.warn(error);
            this.tableLoading=false;
        }
    }

    public async genericMapBaseRouting(routing:RoutingSimulationReport){
        const dialog = this._dialog.open(GenericMapRoutingComponent,{
            data:routing.baseContainers
        })
        dialog.componentInstance.order = routing.baseOrder;

    }

    public async genericMapOptimizeRouting(routing:RoutingSimulationReport){
        const dialog = this._dialog.open(GenericMapRoutingComponent,{
            data:routing.optimizeContainers
        })
        dialog.componentInstance.order = routing.optimizeOrder;
    }

     public async onReportClick() {
          const columns = ["No", "Bölge", "Optimize Rota", "Optimize Konteyner Sayısı","Saf Rota", "Saf Konteyner Sayısı","Kar oranı", "Tarih",];
          let idx = 1;
          const dataset = this._routingSimulationReport.map(p => {
             return {
                 index: idx++,
                 zone: `${p.poligonName}`,
                 optimizeKm: `${p.optimizeKm}`,
                 optimizeCount: `${p.optimizeCount}`,
                 baseKm: `${p.baseKm}`,
                 baseCount: `${p.baseCount}`,
                 kar:`${100-(((p.optimizeKm/p.baseKm)*100))}`,
                 date: `${p.date}`,
              }
          });
          this._excelService.exportAsExcelFile(
              columns,
              dataset,
              'Rota Simülasyon Raporu',
              "",
              new Date(),
              {
                  worksheetName: 'Rota Simülasyon Raporu'
              }
          );
     }

     public async setStartLocation() {
        const dialog = this._dialog.open(SetStartLocationComponent, {
            data: this.myLocation,
            disableClose: false
        })
        dialog.componentInstance.updated.subscribe(x=>{
            this.myLocation = x;
            dialog.close();
        })
    }
    
    public async saveFilter(){
        this.getRoutingSimulation();
        this.updateTableDataSource();
    }

    public async getCurrentLocation():Promise<L.LatLng>{
        return new Promise((resolve,reject)=>{
            navigator.geolocation.getCurrentPosition(position => {
    
                var location = new L.LatLng(position.coords.latitude, position.coords.longitude)
                resolve(location);
            },
                ()=> {
                    return this._toasterService.toastFail(this._translateService.instant("DEVICE_LOCATION_INFORMATION_COULD_NOT_BE_OBTAINED"))
                },
                {
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 5000
                }
            );
        })

    }

    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<RoutingSimulationReport>(this._routingSimulationReport);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;
    }
}
